const useCallTransaction = () => {
  const sendTransaction = async (
    contract,
    method,
    args,
    overrides = null,
    isWaiting = true,
  ) => {
    try {
      const raw = await contract[method](...args, { ...overrides });
      if (raw.hash) {
        if (isWaiting) return await raw.wait();
        return raw;
      }
      return null;
    } catch (error) {
      return error.message;
    }
  };

  const callTransaction = async (contract, method, args, overrides = null) => {
    try {
      return await contract[method](...args, { ...overrides });
    } catch (error) {
      return error.message;
    }
  };

  return { sendTransaction, callTransaction };
};

export default useCallTransaction;
